import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js"; // Function to fetch user data
import {
  getOrgById,
  getOrgByRef,
  transformLogsToTable,
  transformPayoutsToTable,
} from "../../models/OrgFunctions.js"; // Functions to fetch org and client data
import Divider from "../../layout/Divider.js";
import Space from "../../layout/Space.js";
import DataGridFull from "../../tables/DataGridFull.js";
import { Switch, useTheme } from "@mui/material";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import Icon1 from "../../icons/Icon.js";
import {
  getDocDataByRef,
  queryCollection,
} from "../../models/DataFunctions.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import TextField2 from "../../textfields/TextField2.js";
import DropDownGPT0X from "../../dropdowns/DropDownGTP0X.js";
import DataGridGPT2 from "../../tables/DataGridGPT2.js";

function Payouts({ navigateWorkspace }) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [destination, setDestination] = useState("hexagone");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);

  const [selected_log, setSelectedLog] = useState(null);

  const [payouts, setPayouts] = useState([]);
  // Function to navigate to a client by ID
  const gotoUser = async (log) => {
    const obj = await getDocDataByRef(log.ref);
    setSelectedLog(obj);
  };

  // Function to fetch data for the current user
  const handleFetchData = async (destination) => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserById(currentUser.uid);

      // Fetch organization data using the user's org reference
      const org = await getOrgById(user.org_id);
      let payouts = [];
      let filters = [];

      payouts =
        (await queryCollection("payout", [], 5000, "date", "desc")) || [];

      // Transform clients into table format (rows and columns)
      const { rows, columns } = transformPayoutsToTable(payouts, theme, "");

      // Update state if the user data is new or changed
      if (user && user !== userData) {
        setUserData(user);
        setOrgData(org);
        setPayouts(payouts);
        setRows(rows || []);
        setColumns(columns || []);

        // Set options for the search bar (client names)
      }
    }
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData(destination);
    }
  }, [currentUser, destination]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  // Render the client data
  return (
    <div className="flex flex-col h-screen w-full p-4">
      <div className=" flex flex-row w-full h-full">
        <div className="flex flex-col h-full w-full" y={10}>
          <div className="text-hx font-medium">Payouts</div>
          <Space y={10} />
          <div className="flex flex-row w-full items-center">
            {/* Search Bar */}
          </div>

          <Space y={0} />

          {/* DataGrid displaying the clients */}
          <div className="w-full max-h-full pb-8  mb-4 mt-3">
            <div className="max-h-c500   min-h-6">
              <DataGridGPT2
                rows={rows}
                columns={columns}
                initial_sort_field="date"
                initial_asc="desc"
              ></DataGridGPT2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payouts;
